module.exports = __webpack_public_path__ + "img/Carte_Empanadas-w.4bfd5c85.jpg";